export default __webpack_public_path__ + "static/media/lifebuoy.cad36ac2.svg";